package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Web renders inside a skiko canvas, which cannot host a DOM map SDK — the pure-Compose raster
 * [TileMap] is the web map. [interactive] is not needed here: the one static caller lays a
 * gesture-consuming overlay over the map, which already keeps the raster map from panning.
 */
@Composable
actual fun AppMap(
    center: MapPoint,
    zoom: Double,
    onCameraChange: (center: MapPoint, zoom: Double) -> Unit,
    pins: List<MapPin>,
    onPinClick: (String) -> Unit,
    attribution: String,
    modifier: Modifier,
    pinContentDescription: String?,
    clusterContentDescription: ((Int) -> String)?,
    userLocation: MapPoint?,
    radiusKm: Double?,
    radiusCenter: MapPoint?,
    zoomInContentDescription: String?,
    zoomOutContentDescription: String?,
    interactive: Boolean,
    onClusterPinsClick: (List<String>) -> Unit,
) {
    TileMap(
        center = center,
        zoom = zoom,
        onCameraChange = onCameraChange,
        pins = pins,
        onPinClick = onPinClick,
        attribution = attribution,
        modifier = modifier,
        pinContentDescription = pinContentDescription,
        clusterContentDescription = clusterContentDescription,
        userLocation = userLocation,
        radiusKm = radiusKm,
        radiusCenter = radiusCenter,
        zoomInContentDescription = zoomInContentDescription,
        zoomOutContentDescription = zoomOutContentDescription,
        onClusterPinsClick = onClusterPinsClick,
    )
}
